<template>
<div class="chapter">
<div class="inner_page">
<p class="c2" id="calibre_pb_3">A PERMUTED PRESS book</p>
<p class="c1">Published at Smashwords</p>
<p class="c1"> <br class="calibre1"/></p>
<p class="c1">ISBN (Trade Paperback): 978-1-61868-322-9</p>
<p class="c1">ISBN (eBook): 978-1-61868-323-6</p>
<p class="c1"> <br class="calibre1"/></p>
<p class="c1"><i class="calibre2">The Journal</i> copyright © 2014</p>
<p class="c1">by Deborah Moore</p>
<p class="c1">All Rights Reserved.</p>
<p class="c1">Cover art by Matt Mosley</p>
<p class="c1"> <br class="calibre1"/></p>
<p class="c1"><i class="calibre2">This</i> <i class="calibre2">book</i> <i class="calibre2">is</i> <i class="calibre2">a</i>
<i class="calibre2">work</i> <i class="calibre2">of</i> <i class="calibre2">fiction</i>. <i class="calibre2">People</i>, <i class="calibre2">places</i>,
<i class="calibre2">events</i>, <i class="calibre2">and</i> <i class="calibre2">situations</i> <i class="calibre2">are</i> <i class="calibre2">the</i>
<i class="calibre2">product</i> <i class="calibre2">of</i> <i class="calibre2">the</i> <i class="calibre2">author’s</i>
<i class="calibre2">imagination</i>. <i class="calibre2">Any</i> <i class="calibre2">resemblance</i> <i class="calibre2">to</i>
<i class="calibre2">actual</i> <i class="calibre2">persons</i>, <i class="calibre2">living</i> <i class="calibre2">or</i> <i class="calibre2">dead</i>,
<i class="calibre2">or</i> <i class="calibre2">historical</i> <i class="calibre2">events</i>, <i class="calibre2">is</i> <i class="calibre2">purely</i>
<i class="calibre2">coincidental</i>.</p>
<p class="c1"> <br class="calibre1"/></p>
<p class="c1"><i class="calibre2">No</i> <i class="calibre2">part</i> <i class="calibre2">of</i> <i class="calibre2">this</i>
<i class="calibre2">book</i> <i class="calibre2">may</i> <i class="calibre2">be</i> <i class="calibre2">reproduced</i>, <i class="calibre2">stored</i>
<i class="calibre2">in</i> <i class="calibre2">a</i> <i class="calibre2">retrieval</i> <i class="calibre2">system</i>, <i class="calibre2">or</i>
<i class="calibre2">transmitted</i> <i class="calibre2">by</i> <i class="calibre2">any</i> <i class="calibre2">means</i> <i class="calibre2">without</i>
<i class="calibre2">the</i> <i class="calibre2">written</i> <i class="calibre2">permission</i> <i class="calibre2">of</i> <i class="calibre2">the</i>
<i class="calibre2">author</i> <i class="calibre2">and</i> <i class="calibre2">publisher</i>.</p>
<p class="c1"> <br class="calibre1"/></p>
<p class="c1"><img alt="tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1_html_m57db3c65.png" class="calibre5" id="Picture_4" src="tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1_html_m57db3c65.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_004.vue?73fe55a8